import { attributionSchema } from "@medbillai/schemas/attribution";

import type { AttributionTraits } from "../analytics/types";
import { authStorage } from "../storage/instances";

// Not through AuthState, so logout never clears it: stash only while signed
// out or the next account on this device inherits it.
export const stashPendingAttribution = async (traits: AttributionTraits) => {
  if ((await authStorage.get("isAuthenticated")) !== "true") {
    await authStorage.set("pendingAttribution", JSON.stringify(traits));
  }
};

export const readPendingAttribution = async (): Promise<string | undefined> => {
  const raw = await authStorage.get("pendingAttribution");
  if (!raw) {
    return undefined;
  }
  try {
    return attributionSchema.safeParse(JSON.parse(raw)).success
      ? raw
      : undefined;
  } catch {
    return undefined;
  }
};
